var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google-logo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.4450964,32.1584241 L66.496228,32.1584241 L75.1886002,23.466052 L75.6160939,19.7778709 C59.4425817,5.50293378 34.7527242,7.04107293 20.4777871,23.2145851 C16.5088013,27.7074602 13.6295054,33.0511316 12.0620285,38.8348701 C13.030176,38.4367142 14.1031014,38.3738474 15.1131601,38.650461 L32.4937133,35.7837385 C32.4937133,35.7837385 33.3780386,34.3210394 33.8348701,34.4132439 C41.5674769,25.9220453 54.5808885,24.9329422 63.5079631,32.1584241 L63.4450964,32.1584241 Z",
    id: "Path",
    fill: "#EA4335",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5691534,38.8348701 C85.5699916,31.4794635 81.4710813,24.8658843 75.766974,19.8072087 L63.5708298,32.0033529 C68.72171,36.2112322 71.6554904,42.5523889 71.5297569,49.2036882 L71.5297569,51.3704946 C77.5272422,51.3704946 82.3847443,56.2321878 82.3847443,62.225482 C82.3847443,68.2229673 77.5230511,73.0804694 71.5297569,73.0804694 L49.8155909,73.0804694 L47.6487846,75.2766136 L47.6487846,88.2984074 L49.8155909,90.4652137 L71.5297569,90.4652137 C83.977368,90.5616094 95.0209556,82.4937133 98.7175189,70.6077117 C102.4057,58.7175189 97.8792959,45.8088852 87.5691534,38.8348701 L87.5691534,38.8348701 Z",
    id: "Path",
    fill: "#4285F4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0720872,90.3436714 L49.7862531,90.3436714 L49.7862531,72.9631182 L28.0720872,72.9631182 C26.5255658,72.9631182 24.9958089,72.6320201 23.5875943,71.9865884 L20.5364627,72.9295893 L11.7854149,81.6219614 L11.022632,84.673093 C15.9304275,88.3780386 21.9195306,90.3688181 28.0720872,90.3436714 L28.0720872,90.3436714 Z",
    id: "Path",
    fill: "#34A853",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0720872,33.9562558 C16.0100587,34.0276614 5.32690696,41.751886 1.47946354,53.1810562 C-2.36797988,64.6102263 1.46689019,77.225482 11.0268231,84.5766974 L23.6211232,71.9823973 C18.1559095,69.5138307 15.729254,63.0846605 18.1978206,57.6194468 C20.6663873,52.154233 27.0955574,49.7275775 32.5607712,52.1961442 C34.9664711,53.285834 36.8943839,55.2137469 37.9840738,57.6194468 L50.5783738,45.0251467 C45.217938,38.0217938 36.8901928,33.9270746 28.0720872,33.9562558 L28.0720872,33.9562558 Z",
    id: "Path",
    fill: "#FBBC05",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.fb36c403528bab30f29ab4738100d175.svg";
export { ForwardRef as ReactComponent };